import { Controller } from "@hotwired/stimulus"

// All evidence, geometry and drilldown navigation comes from Rails.
export default class extends Controller {
  static targets = ["svg"]

  connect() {
    this.initial = this.svgTarget.getAttribute("viewBox").split(/\s+/).map(Number)
    this.view = [...this.initial]
    this.drag = null
    this.suppressClick = false
  }

  disconnect() { this.drag = null }
  draw() { this.svgTarget.setAttribute("viewBox", this.view.join(" ")) }
  reset() { this.view = [...this.initial]; this.draw() }
  zoomIn() { this.zoom(0.8) }
  zoomOut() { this.zoom(1.25) }

  zoom(factor) {
    const width = Math.min(this.initial[2] * 1.5, Math.max(this.initial[2] / 6, this.view[2] * factor))
    const height = width * this.initial[3] / this.initial[2]
    this.view = [this.view[0] + (this.view[2] - width) / 2, this.view[1] + (this.view[3] - height) / 2, width, height]
    this.draw()
  }

  startPan(event) {
    if (event.button !== 0 || !event.isPrimary) return
    this.suppressClick = false
    this.drag = { pointer: event.pointerId, x: event.clientX, y: event.clientY, view: [...this.view], moved: false }
  }

  pan(event) {
    if (!this.drag || event.pointerId !== this.drag.pointer) return
    if (event.buttons === 0) {
      this.endPan(event)
      this.suppressClick = false
      return
    }
    const dx = event.clientX - this.drag.x, dy = event.clientY - this.drag.y
    if (!this.drag.moved && Math.hypot(dx, dy) < 5) return
    const box = this.svgTarget.getBoundingClientRect()
    if (!box.width || !box.height) return
    this.drag.moved = true
    this.svgTarget.setPointerCapture(event.pointerId)
    const scale = Math.max(this.drag.view[2] / box.width, this.drag.view[3] / box.height)
    this.view = [this.drag.view[0] - dx * scale, this.drag.view[1] - dy * scale, ...this.drag.view.slice(2)]
    this.draw()
  }

  endPan(event) {
    if (!this.drag || event.pointerId !== this.drag.pointer) return
    this.suppressClick = this.drag.moved
    this.drag = null
    if (this.svgTarget.hasPointerCapture(event.pointerId)) this.svgTarget.releasePointerCapture(event.pointerId)
  }

  onClick(event) {
    if (!this.suppressClick || event.detail === 0) return
    event.preventDefault()
    event.stopPropagation()
    this.suppressClick = false
  }

  drill(event) {
    if (event.metaKey || event.ctrlKey || event.shiftKey || event.altKey || (event.button && event.button !== 0)) return
    event.preventDefault()
    window.Turbo.visit(event.currentTarget.getAttribute("href"))
  }

  keyPan(event) {
    if (event.target !== this.svgTarget) return
    const moves = { ArrowLeft: [-1, 0], ArrowRight: [1, 0], ArrowUp: [0, -1], ArrowDown: [0, 1] }
    if (["+", "=", "-", "Home"].includes(event.key)) {
      event.preventDefault()
      if (event.key === "Home") this.reset()
      else this.zoom(event.key === "-" ? 1.25 : 0.8)
    } else if (moves[event.key]) {
      event.preventDefault()
      this.view[0] += moves[event.key][0] * this.view[2] * 0.08
      this.view[1] += moves[event.key][1] * this.view[3] * 0.08
      this.draw()
    }
  }
}
